export default __webpack_public_path__ + "static/warning-icon-6e64b8dddf75ebf91904c5c77a75a23c.svg";